import React from 'react'
import { CircularProgress } from '@mui/material'

/**
 * @typedef {Object} LoadingMessageProps
 * @property {string} [message]
 * @property {boolean} [showSpinner]
 * @property {number} [spinnerSize]
 * @property {string} [minHeightClassName]
 * @property {string} [className]
 * @property {string} [testId]
 */

/**
 * 共通ローディング表示（「読み込み中…」）
 *
 * @param {LoadingMessageProps} props
 * @returns {JSX.Element}
 */
const LoadingMessage = ({
  message = '読み込み中...',
  showSpinner = true,
  spinnerSize = 24,
  minHeightClassName = 'min-h-[200px]',
  className = '',
  testId = 'loadingMessage'
}) => {
  return (
    <div data-testid={testId} className={`${minHeightClassName} grid place-items-center ${className}`.trim()}>
      <div className="flex flex-col items-center gap-3">
        {showSpinner && <CircularProgress size={spinnerSize} style={{ color: '#3150A5' }} />}
        <p className="max-w-[560px] text-center text-h5 font-bold grey--text truncate">{message}</p>
      </div>
    </div>
  )
}

export default LoadingMessage
